import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { setGlobalDialogTips, setUnreadTasks } from '../../store/memberSlice';

export default function UnreadNotificationDialog() {
    const unreadTasks = useSelector((state: RootState) => state.member.unreadTasks);
    const globalDialogTips = useSelector((state: RootState) => state.member.globalDialogTips);
    const dispatch = useDispatch();
    const currentTaskIdRef = useRef<string | null>(null);

    const giftTasks = unreadTasks.filter(t => t.taskType === 'gift_code_redeem');

    useEffect(() => {
        // no more points_grant items — reset and stop
        if (giftTasks.length === 0) {
            currentTaskIdRef.current = null;
            return;
        }

        // TipsDialog just closed our previous notification — advance to next
        if (globalDialogTips === null && currentTaskIdRef.current !== null) {
            currentTaskIdRef.current = null;
            return;
        }

        // already showing a dialog (ours or from elsewhere) — don't overwrite
        if (globalDialogTips !== null) return;

        // start showing the first pending notification
        const current = giftTasks[0];
        currentTaskIdRef.current = current.taskId;
        const amount = current.result?.rewardAmount ?? '';

        const dismiss = () => {
            dispatch(setUnreadTasks(unreadTasks.filter(t => t.taskId !== current.taskId)));
        };

        if (current.status === 'success') {
            dispatch(setGlobalDialogTips({
                type: 'success',
                title: '礼品码兑换成功！',
                content: amount ? `礼品码兑换成功` : `礼品码兑换成功，获得 ${amount} 水滴。`,
                buttonContent: '确认',
                confirmFun: dismiss,
                cancelFun: dismiss,
            }));
        } else {
            dispatch(setGlobalDialogTips({
                type: 'error',
                title: '礼品码兑换失败',
                content: current.errorMessage || '兑换失败，请重试。',
                buttonContent: '确认',
                confirmFun: dismiss,
                cancelFun: dismiss,
            }));
        }
    }, [giftTasks, globalDialogTips, dispatch, unreadTasks]);

    return null;
}
